import React from 'react';
import { PaymentQrCodeInfo } from 'components';

const PaymentQRCodeComponent = (props) => {
    return <PaymentQrCodeInfo {...props} />;
};

export default PaymentQRCodeComponent;
